import { FC, useEffect, useState } from 'react';
import PropTypes from 'prop-types';
import { Button, Card, CardActions, CardContent, CardHeader, Grid, Radio, Table,
  TableBody, TableCell, TableContainer, TableHead, TableRow, Typography, } from '@material-ui/core';
import { ServicePriceMasterView } from 'src/interfaces/masters/Price/price';
import { MODE_OF_PAYMENT } from 'src/constants/repairRequest-constants';
import { getTotalTaxes } from 'src/components/masters/customFunctions';
import { ICoupon } from 'src/interfaces/new-channel-partner/channelPartner';
import { InputField } from 'src/components/input-field';
import { couponApi } from 'src/api/coupon';
import { useAuth } from 'src/hooks/use-auth';
import { Roles } from 'src/enums/role-based-auth-guard';

interface RaiseRequestPaymentCardProps {
  servicePriceDetails: ServicePriceMasterView;
  setModeOfPayment : (data: string) => void;
  setCoupon: (Data: ICoupon) => void;
}

export const RaiseRequestPaymentCard: FC<RaiseRequestPaymentCardProps> = (props) => {
  const { servicePriceDetails, setModeOfPayment, setCoupon } = props;
  const [selectedPaymentMode, setSelectedPaymentMode] = useState<string>('');
  const [couponsList, setCouponsList] = useState<Array<any>>([]);
  const [appliedCoupon, setAppliedCoupon] = useState<string | null>();
  const [activePrice, setActivePrice] = useState<any>();
  const [availableDiscount, setAvailableDiscount] = useState(0);
  const [paymentTypes, setPaymentTypes] = useState<any[]>(MODE_OF_PAYMENT);
  const { user } = useAuth();

  useEffect(() => {
    const active = servicePriceDetails?.prices?.filter((price) => price?.active);
    setActivePrice(active[0]);
  }, []);

  useEffect(() => {
    if (user?.scope === Roles.DEALER) {
      const paymentType = paymentTypes.filter((payment) => payment.value !== 'Cash');
      setPaymentTypes(paymentType);
    }
  }, [user]);

  console.log(setCoupon, appliedCoupon);
  const modsOfPaymentHandler = (value: string) => {
    setSelectedPaymentMode(value);
    setModeOfPayment(value);
  };

  const getTotalGst = () => Number(getTotalTaxes(activePrice?.sellingPrice - availableDiscount,
    servicePriceDetails?.gst?.igst))?.toFixed(2);

  const getTotalAmount = () => {
    const sellingPrice = activePrice?.sellingPrice - availableDiscount;
    const igst = servicePriceDetails?.gst?.igst;
    if (sellingPrice && igst >= 0) {
      const totalAmount = (sellingPrice + ((igst / 100) * sellingPrice)).toFixed(2);
      return totalAmount;
    }
    return 0;
  };

  const getAllCoupons = () => {
    try {
      couponApi
        .getAllCoupons()
        .then((response) => setCouponsList(response?.responseData))
        .catch((error) => console.error(error));
    } catch (error) {
      console.error(error);
    }
  };

  useEffect(() => {
    getAllCoupons();
  }, []);

  const applyCouponhandler = () => {
    const couponDetails = couponsList
      ?.filter((couponDetail) => couponDetail?.code?.toLowerCase() === appliedCoupon.toLowerCase());
    if (couponDetails?.length > 0) {
      const cp = couponDetails[0];
      const discount = activePrice?.sellingPrice * (cp.percentage / 100);
      setAvailableDiscount(discount);
      setCoupon({
        code: cp?.code?.toLowerCase(),
        discount,
      });
    }
  };

  const removeCouponHandler = () => {
    setAppliedCoupon(null);
    setAvailableDiscount(0);
    setCoupon(null);
  };

  const renderAddressTypeRadio = (label: string, value: string) => (
    <Grid
      item
      xs={4}
      pt={0}
    >
      <Radio
        checked={value === selectedPaymentMode}
        onChange={() => modsOfPaymentHandler(value)}
      />
      <Typography
        variant="body2"
        display="contents"
      >
        {label}
      </Typography>
    </Grid>

  );

  return (activePrice
    ? (
      <>
        <Card
          variant="outlined"
          sx={{ mt: 1 }}
        >
          <CardHeader
            title="Payment"
          />
          <CardContent>
            <Grid
              container
              spacing={2}
              direction="row"
              xl={7}
              lg={12}
              xs={12}
            >

              <Grid
                item
                sm={5}
                xs={12}
              >
                <TableContainer>
                  <Table
                    stickyHeader
                    size="small"
                    sx={{
                      border: 1,
                      borderColor: '#e1e3ea',
                      borderRadius: '2px',
                    }}
                  >
                    <TableHead>
                      <TableRow
                        key="productDetails"
                      >
                        <TableCell
                          sx={{
                            backgroundColor: 'neutral.100',
                          }}
                        >
                          Description
                        </TableCell>
                        <TableCell
                          sx={{
                            backgroundColor: 'neutral.100',
                          }}
                          align="right"
                        >
                          Amount
                        </TableCell>
                      </TableRow>
                    </TableHead>
                    <TableBody>
                      <TableRow
                        hover
                        key="Repair Service"
                      >
                        <TableCell>
                          Repair Service Charges
                        </TableCell>
                        <TableCell
                          align="right"
                        >
                          &#8377;&nbsp;
                          {Number(activePrice?.sellingPrice)?.toFixed(2)}
                        </TableCell>
                      </TableRow>
                      {availableDiscount > 0 ? (
                        <TableRow
                          hover
                          key="coupon"
                        >
                          <TableCell>
                            Coupon Discount
                          </TableCell>
                          <TableCell
                            align="right"
                          >
                            {`- ₹ ${Number(availableDiscount)?.toFixed(2)}`}
                          </TableCell>
                        </TableRow>
                      ) : <></>}
                      <TableRow
                        hover
                        key="Repair Service"
                      >
                        <TableCell>
                          {`GST (${servicePriceDetails?.gst?.igst}%)`}
                        </TableCell>
                        <TableCell
                          align="right"
                        >
                          &#8377;&nbsp;
                          {getTotalGst()}
                        </TableCell>
                      </TableRow>
                      <TableRow
                        hover
                        key="Total"
                      >
                        <TableCell>
                          <strong>
                            Total Amount
                          </strong>
                        </TableCell>
                        <TableCell
                          align="right"
                        >
                          <strong>
                            &#8377;&nbsp;
                            {getTotalAmount()}
                          </strong>
                        </TableCell>
                      </TableRow>
                    </TableBody>
                  </Table>
                </TableContainer>
              </Grid>
              <Grid
                item
                sm={7}
                xs={12}
              >
                <Grid
                  container
                  direction="row"
                  pb={2}
                >
                  <Grid
                    xs={8}
                  >
                    {' '}
                    {availableDiscount ? (
                      <Typography
                        variant="h6"
                        color="green"
                        sx={{
                          display: 'inline'
                        }}
                      >
                        {`${appliedCoupon?.toUpperCase()} Coupon Applied..!`}
                      </Typography>
                    ) : (
                      <InputField
                        fullWidth
                        onChange={(event) => setAppliedCoupon((event.target.value).trim())}
                        placeholder="Enter Coupon Code"
                      />
                    )}

                  </Grid>
                  <Grid
                    xs={4}
                    pl={1}
                  >
                    {availableDiscount ? (
                      <Button
                        fullWidth
                        color="error"
                        variant="contained"
                        onClick={removeCouponHandler}
                      >
                        Remove
                      </Button>
                    ) : (
                      <Button
                        fullWidth
                        disabled={!appliedCoupon}
                        onClick={applyCouponhandler}
                        variant="contained"
                      >
                        Apply
                      </Button>
                    )}

                  </Grid>
                </Grid>
                <Card
                  variant="outlined"
                >
                  <CardHeader
                    title="Mode Of Payment"
                  />
                  <CardContent sx={{ p: 1, pb: 0 }}>
                    <Grid
                      container
                      spacing={1}
                      direction="row"
                      xs={12}
                    >
                      {paymentTypes.map((item) => (
                        renderAddressTypeRadio(item.label, item.value)
                      ))}
                    </Grid>
                  </CardContent>
                  <CardActions sx={{ p: 0 }} />
                </Card>
              </Grid>
            </Grid>

          </CardContent>
        </Card>
      </>
    ) : <></>
  );
};

RaiseRequestPaymentCard.propTypes = {
  // @ts-ignore
  servicePriceDetails: PropTypes.object,
  setModeOfPayment: PropTypes.func,
  setCoupon: PropTypes.func
};
